



















































































import { Vue, Component } from 'vue-property-decorator'
import PracticeDummy1 from '@/components/student/organisms/PracticeDummy1.vue'
import PracticeDummy2 from '@/components/student/organisms/PracticeDummy2.vue'
import PracticeDummy3 from '@/components/student/organisms/PracticeDummy3.vue'
import PracticeDummy4 from '@/components/student/organisms/PracticeDummy4.vue'
import WebIME from '@/plugins/webime'

Vue.use(WebIME)

const common = require('../../../public/dummy/practice/js/common-module.js')

@Component({
  components: {
    PracticeDummy1,
    PracticeDummy2,
    PracticeDummy3,
    PracticeDummy4,
  },
})
export default class StudentPractice extends Vue {
  private currentTagName = 'tag1'

  private resetKey = 0

  private mounted() {
    //frame限定
    common.pageCreate()
    common.footerReset()
    common.selectTag(this.currentTagName)

    let scriptEl = document.createElement('script')
    scriptEl.setAttribute('src', '/dummy/practice/js/common.js')
    ;(document.getElementById('base') as HTMLElement).appendChild(scriptEl)
  }

  private get currentComponent() {
    return `PracticeDummy${this.currentTagName.slice(-1)}`
  }

  private get isFooterNaviNext(): boolean {
    return this.currentTagName === 'tag1' ? true : false
  }

  private get isFooterNaviPrev(): boolean {
    return this.currentTagName === 'tag2' ? true : false
  }

  private click2(mode: string) {
    const index = Number(this.currentTagName.slice(-1)) + (mode == 'next' ? 1 : -1)
    if (index <= 4) {
      this.currentTagName = `tag${index}`
      const target = document.getElementById(this.currentTagName)
      if (target) target.dispatchEvent(new Event('click'))
    } else {
      // 終わりボタン押下時
      this.$router.push({ name: 'StudentLogin' })
    }
  }

  private click3() {
    // やり直し
    this.resetKey++
  }

  private get currentQuestionCount() {
    return `${this.currentTagName.slice(-1)}問目/4問中`
  }
}
